import { SerializedError } from "../protocol";

export class EngineWorkerError extends Error {
  constructor(message: string, options?: { name?: string } & ErrorOptions) {
    super(message, options);
    this.name = options?.name ?? "EngineWorkerError";
  }

  static fromSerialized({ message, name }: SerializedError) {
    return new EngineWorkerError(message, { name });
  }
}
